<template>
  <v-select
    :items="items"
    :clearable="clearable"
    item-text="name"
    item-value="id"
    :no-data-text="$t('NO_DATA')"
    :label="$t('fields.warehouse')"
    :error-messages="errors"
    @input="changed"
    v-model="selected"
  >
  </v-select>
</template>
<script>

import { warehousesService } from '../../../utils/services/warehouses.service';

export default {
  name: 'WarehouseAvailablesSelect',
  props: {
    errors: {
      type: [String, Array],
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      selected: this.value,
      items: [],
    };
  },
  methods: {
    changed(event) {
      this.$emit('input', event);
    },

    async fetchWarehouse() {
      return warehousesService.index({
        propagandist_id: 0,
        is_default: 0,
      })
      .then(response => {
          this.items = response.data.data;
      })
      .catch(error => {
          this.handleError(error, this.errors);
      });
    },
  },
  async created() {
    await this.fetchWarehouse();
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selected = val;
      },
    },
  },
};
</script>
